export default __webpack_public_path__ + "static/media/EM1780.34I-43290_-25877_0.1adeed72.jpg";